module.exports = __webpack_public_path__ + "img/0Q3A3001_L_Wood_MockedUp.4b175568.jpg";